import styled from 'styled-components';

export const Adicionar = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`;

export const BotaoDisciplina = styled.div`
  width: 25%;
  margin: 0rem auto;

  a {
    background-color: transparent;
    color: transparent;
  }

  button {
    margin: 1rem 0rem 0rem 0rem;
    background-color: white;
    width: 100%;
    color: black;
  }

  button:hover {
    background-color: #ddd;
  }
`;

export const Concursos = styled.div`
form {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

input {
  margin-bottom: 0.5rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}

input:hover {
  background-color: #ddd;
}

#left {
  width: 45%;
  margin-right: 5rem;
}

#right {
  width: 45%;
}

label {
  font-size: 0.7em;
  font-weight: 700;
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
}

#submit-concurso {
  margin: 1rem auto 0rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  button {
    background-color: white;
    width: 25%;
    color: black;
  }

  button:hover {
    background-color: #ddd;
  }
}
`;

export const SelectNome = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const NomeEmpresa = styled.div`
  width: 100%;

  span {
    font-size: 0.7em;
    font-weight: 700;
    color: white;
  }

  p {
    background-color: white;
    padding: 0.5rem;
    border-radius: 5px;
    height: 2rem;
  }
`;

export const Botoes = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: baseline;

  a {
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    margin: 2rem 0rem 1rem 0rem;

    P {
      font-size: 0.8em;
    }
  }
`;
